import React, { CSSProperties, FC } from 'react'

import * as RadixTooltip from '@radix-ui/react-tooltip'

import './Tooltip.scss'

interface TooltipProps {
  content: React.ReactNode | string
  side?: 'top' | 'right' | 'bottom' | 'left'
  children?: React.ReactNode,
  style?: CSSProperties,
}

const {
  Root, Trigger, Content, Arrow,
} = RadixTooltip

export const Tooltip: FC<TooltipProps> = ({
  content,
  side = 'right',
  children,
  style,
}) => (
  <Root delayDuration={10}>
    <Trigger
      // asChild
      style={{
        all: 'initial',
        margin: 0,
        padding: 0,
        border: 'none',
      }}
    >
      {children}
    </Trigger>
    <Content
      className="tooltip-content"
      side={side}
      align="center"
      alignOffset={-5}
      style={{
        zIndex: 9999,
        maxWidth: 400,
        flexWrap: 'wrap',
        ...style,
      }}
    >
      {content}
      <Arrow
        style={{
          fill: 'white',
          stroke: 'var(--slate8)',
          strokeWidth: 2,
          transform: 'translateY(-1px)',
          strokeDasharray: 34,
          strokeDashoffset: -31,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 12,
        }}
        offset={6}
      />
    </Content>
  </Root>
)
